const GET_LIST = "local/GET_LIST";
const GET_LIST_SUCCESS = "local/GET_LIST_SUCCESS";
const GET_LIST_ERROR = "local/GET_LIST_ERROR";
const SET_FILTERS = "local/SET_FILTERS";
const SET_PAGINATION = "local/SET_PAGINATION";

export default {
  GET_LIST,
  GET_LIST_SUCCESS,
  GET_LIST_ERROR,
  SET_FILTERS,
  SET_PAGINATION,
};



// WEBPACK FOOTER //
// ./src/infraMonitor/localTypes.js